const metadataSlice = {
    navButtons: {
        builder: true,
        preset: false
    }
}

export default metadataSlice
export { metadataSlice }



// WEBPACK FOOTER //
// ./src/app/configuration/ComcastPremarket/config/components/selection/MetadataSlice/index.js